<template>
    <div class="computeResource_wrap">
        <el-page-header @back="$core.goBack"></el-page-header>
        <!-- 头部内容 -->
        <div class="compute_top">
            <div class="compute_top_content">
                <div class="top_title">智能计算资源专区</div>
                <div>作为大容量、高性能计算平台，包含基础版（(Jupyter Notebook运行资源1G)与进阶版（添加CPU、GPU计算资源)，可满足用户的不同计算需求。</div>
            </div>
        </div>
        <div class="start_wrap">
            <div class="start_item">
                <div class="start_title">
                    <i class="iconfont icon-jichu"></i>
                    <span> 基础版</span>
                </div>
                <div class="item_list">
                    <div class="flex-start"><i class="iconfont icon-dian"></i><span> 作为开源的web应用程序,可创建和共享包含实时代码、方程式、可视化和叙述文本的文档。</span></div>
                    <div class="flex-start"><i class="iconfont icon-dian"></i><span> 可用于数据清理和转换、数值模拟、统计建模、数据可视化、机器学习等。</span></div>
                    <div class="flex-start"><i class="iconfont icon-dian"></i><span> Notebook导出方式简单快捷,可导出为HTML、Markdown、PDF等格式。</span></div>
                </div>
                <div class="start_button"><el-button plain type="primary">启动环境</el-button></div>
            </div>
            <div class="start_item">
                <div class="start_title">
                    <i class="iconfont icon-shishishuju"></i>
                    <span> 进阶版</span>
                </div>
                <div class="item_list">
                    <div class="flex-start"><i class="iconfont icon-dian"></i><span> 可灵活选择所需计算资源,可用计算资源包含8核32G CPU、4核16G CPU、2核8G CPU以及T4Tenaor Core GPU。</span></div>
                    <div class="flex-start"><i class="iconfont icon-dian"></i><span> 支持以分钟为单位购买所需计算时长,可实时查看资源使用实况。</span></div>
                    <div class="flex-start"><i class="iconfont icon-dian"></i><span> 可在已购买计算资源时长结束前随时补充计算时长。</span></div>
                </div>
                <div class="start_button"><el-button plain type="primary" @click="toPurchase">开始使用</el-button></div>
            </div>
        </div>
        <div class="compute_bottom_wrap">
            <div class="compute_bottom_title">
                <div>智能计算资源专区</div>
                <div class="compute_text">大容量、高性能计算平台</div>
            </div>
            <div class="characteristic_wrap">
                <div class="characteristic_title"><span>平台特点</span></div>
                <div class="characteristic_list">
                    <div>
                        <div><i class="iconfont icon-feiyongbaohan"></i></div>
                        <div>按时间灵活计费</div>
                    </div>
                    <div>
                        <div><i class="iconfont icon-jisuan"></i></div>
                        <div>一键配置计算环境 </div>
                    </div>
                    <div>
                        <div><i class="iconfont icon-huanjingjiance"></i></div>
                        <div>平台24小时开放使用</div>
                    </div>
                    <div>
                        <div><i class="iconfont icon-icon-"></i></div>
                        <div>摆脱物理环境限制,可随处链接</div>
                    </div>
                    
                    <div>
                        <div><i class="iconfont icon-ziyuan-xianxing"></i></div>
                        <div>高效利用灵活配置资源</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return{

            }
        },
        created(){
            // let url = document.location.href;
        },
        mounted(){
         
        },
        methods: {
            //进阶版购买资源
            toPurchase(){
                this.$router.push('/purchaseResources')
            }
        }
    }
</script>

<style lang="scss" scoped>
.compute_bottom_wrap{
    height: 1280px;
    margin: 100px 0px;
    background: url(../../../assets/img/compute_bottom_bg.png) 0 0/100% 100% no-repeat;
    .compute_bottom_title{
        color: #5277F7;
        text-align: center;
        padding-top: 200px;
        font-size: 35px;
        font-weight: 600;
        line-height: 2;
        letter-spacing: 2px;
        .compute_text{
            font-size: 20px;
            letter-spacing: 0px;
            // font-weight: 60;
        }
    }
    .characteristic_wrap{
        margin-top: 200px;
        margin-left: 150px;
        width: 35vw;
        color: #333;
        .characteristic_title{
            position: relative;
            left:4vw;
            span{
                font-size: 35px;
                font-weight: bold;
                line-height: 2;
                padding-bottom: 5px;
                letter-spacing: 2px;
                border-bottom: 4px solid #5277F7;
            }
        }
        .characteristic_list{
            margin-top: 50px;
            display: flex;
            flex-wrap: wrap;
            >div{
                text-align: center;
                width: 17vw;
                margin-bottom: 40px;
                font-size: 20px;
                // font-weight: bold;
                >div{
                    margin-top: 8px;
                }
                i{
                    font-size: 50px;
                    margin-bottom: 15px;
                }
            }
            
        }
    }
    
}
.start_wrap{
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 60px 400px;
    .start_item{
        text-align: center;
        width: 43%;
        box-sizing: border-box;
        padding: 0px 20px;
        color: #333;
        
        .start_title{
            height: 80px;
            line-height: 100px;
            font-size: 23px;
            font-weight: bold;
            letter-spacing: 1px;
            opacity: 0.9;
        }
        .item_list{
            text-align: justify;
            font-size: 20px;
            line-height: 1.6;
            letter-spacing: 1px;
            height: 280px;
            div{
                margin-top: 15px;
            }
            i{
                color: #5277F7;
                margin-right: 2px;
            }
        }
        .start_button{
            height: 60px;
            line-height: 60px;
        }
        i{
            font-size: 23px;
            
        }
    }
    .start_item:hover{
        cursor: pointer;
        border-top: 3px solid #5277F7;
        box-shadow: 0px 3px 6px rgba(139, 139, 139, 0.16);
    }
}
.computeResource_wrap{
    position: relative;
}
.compute_top{
    height: 440px;
    background: url(../../../assets/img/compute_top_bg.png) 0 0/100% 100% no-repeat;
    display: flex;
    justify-content: center;
    align-items: center;
    .compute_top_content{
        max-width: 800px;
        text-align: center;
        line-height: 2;
        font-size: 18px;
        letter-spacing: 1px;
        color: #333;
        .top_title{
            opacity: 0.9;
            margin: auto;
            font-size: 40px;
            font-weight: bold;
            padding-bottom: 20px;
            border-bottom: 5px solid #5277F7;
            margin-bottom: 40px;
        }
    }
}
</style>

